export default __webpack_public_path__ + "static/media/study-about-3.32614744.png";